export const isProduction = new Set(['secure.speedycash.com', 'secure.speedycash.prod.ccfi.cloud', 'secure.titlemax.com']).has(window.location.hostname);
